import React from 'react'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const EasyPayPlanTitle = () => {
  const { t } = useTranslation()

  return (
      <Typography style={{ fontSize: '16px', fontWeight: 700, margin: '16px 0' }}>
        {t('easyPayPlan.moveIntoHomeWithoutPayingAnything')}
      </Typography>
  )
}
